import { admGraphqlRequest } from 'core/utils/backend-service';
import { PredefinedComment } from '../predefined-comments.model';
import {
    createPredefinedCommentMutation,
    editPredefinedCommentMutation,
    getPredefinedCommentsListQuery,
    getSinglePredefinedCommentQuery,
    updatePredefinedCommentActiveStatusMutation,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/service/predefined-comments.queries';
import { PredefinedCommentFormModel } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import {
    mapPredefinedCommentApiToForm,
    mapPredefinedCommentFormToAPI,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/service/predefined-comments-api.mapper';

export const getPredefinedCommentsList = (onlyActive: boolean): Promise<PredefinedComment[]> =>
    admGraphqlRequest(getPredefinedCommentsListQuery(), { onlyActive }).then(
        (result) => result.data.predefinedComments
    );

export const createPredefinedComment = (comment: PredefinedCommentFormModel): Promise<string> =>
    admGraphqlRequest(createPredefinedCommentMutation(), {
        comment: mapPredefinedCommentFormToAPI(comment),
    }).then((result) => result.data.createPredefinedComment);

export const updatePredefinedCommentActiveStatus = (ids: string[], active: boolean): Promise<void> =>
    admGraphqlRequest(updatePredefinedCommentActiveStatusMutation(), { ids, enabled: active }).then(
        (result) => result.data.updatePredefinedCommentEnableStatus
    );

export const getSinglePredefinedComment = (id: string): Promise<PredefinedCommentFormModel> =>
    admGraphqlRequest(getSinglePredefinedCommentQuery(), { id }).then((result) =>
        mapPredefinedCommentApiToForm(result.data.predefinedComment)
    );

export const updatePredefinedComment = (id: string, comment: PredefinedCommentFormModel): Promise<void> =>
    admGraphqlRequest(editPredefinedCommentMutation(), {
        id,
        comment: mapPredefinedCommentFormToAPI(comment),
    }).then((result) => result.data.updatePredefinedComment);
